import React from 'react';
import Tool, { type IToolActionInput, type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from '../styles.module.css';
import WhiteboardController from '../controllers/WhiteboardController';
import stickyStackIcon from '../assets/icons/stickyStack.svg';
import { hasEndlessStackBehaviors, isEndlessStack } from '../objects/guards';
import { svgToIcon } from '../utils/svg';

const toggleEndlessButton = (): ToolButtonComponent => {
  return ApplicationView(({ selection, tool }) => {
    const controller = useController(WhiteboardController);
    const obj = selection.firstObject();
    const endlessStack = isEndlessStack(obj);

    const label = endlessStack ? 'Disable to move' : '';
    const className = endlessStack ? styles.toolButtonWithSideLabel : '';

    return (
      <ToolButton
        className={className}
        onClick={() => {
          if (hasEndlessStackBehaviors(selection)) {
            ToolEndlessStack.action({ controller, selection });
          }
        }}
        tool={tool}
        active={endlessStack}
      >
        {svgToIcon(stickyStackIcon)}
        {label && <span className={styles.toolButtonSideLabel}>{label}</span>}
      </ToolButton>
    );
  });
};

class ToolEndlessStack extends Tool {
  static toolName = 'Endless stack';

  static action({ controller, selection }: IToolActionInput) {
    const obj = selection.firstObject();
    const endlessStack = isEndlessStack(obj);
    obj.set({
      endlessStack: !endlessStack,
    });
    controller.actionRerenderToolbar();
  }

  static buttonComponent() {
    return toggleEndlessButton();
  }
}

export default ToolEndlessStack;
